module.exports = __webpack_public_path__ + "img/Bilde2.0aa5ba77.jpg";